export const dateFormat = 'MM/DD/YY';